import _ from 'lodash';
import keyCode from 'keycode';
import Note from './Note';
import mutateNote from './mutateNote';

export default function keyListener(programmer) {
  let played = [];
  const showPlayed = _.debounce(() => {
    const base = played[0];
    console.log(played.map(p => p - base));
    played = [];
  }, 1500);

  window.addEventListener('keypress', (e) => {
    const key = parseInt(keyCode(e), 10);
    if (_.isFinite(key)) {
      const note = new Note(key, programmer.instruments[0])
      const mutatedNote = mutateNote(note, programmer.mutations);
      console.log(mutatedNote);
      _.flatten([mutatedNote]).forEach(n => n.play() );

      played.push(key)
      showPlayed();
    }
  });
}



// WEBPACK FOOTER //
// ./src/keyboardPlayer.js